import {
  getObject,
  getOptionalObject,
  getList,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "../types/code";
import { SurveyLocalizedText, SurveyLocalizedTextDTO } from "../assets/surveyLocalizedText";
import { OpenEndedResultV1, OpenEndedResultV1DTO } from "./openEndedResultV1";

export interface OpenEndedFieldResultV1DTO {
  fieldCode: CodeDTO;
  fieldName?: SurveyLocalizedTextDTO | null;
  openEndedResultsV1: OpenEndedResultV1DTO[];
}

export class OpenEndedFieldResultV1 {
  readonly isOpenEndedFieldResultV1OpenEndedFieldResultV1: boolean = true;

  readonly fieldCode: Code;
  readonly fieldName: SurveyLocalizedText | null;
  readonly openEndedResultsV1: OpenEndedResultV1[];

  static readonly constraints = {
    "openEndedResultsV1": {
      "maxSize": 50,
    }
  }

  constructor(
  fieldCode: Code, 
  fieldName: SurveyLocalizedText | null = null, 
  openEndedResultsV1: OpenEndedResultV1[]
  ) {
    this.fieldCode = fieldCode;
    this.fieldName = fieldName;
    OpenEndedFieldResultV1.validateOpenEndedResultsV1(openEndedResultsV1);
    this.openEndedResultsV1 = openEndedResultsV1;
  }

  static fromDTO(dto: OpenEndedFieldResultV1DTO): OpenEndedFieldResultV1 {
    const fieldCode = Code.fromDTO(getObject(dto, "fieldCode", InvalidOpenEndedFieldResultV1FieldCodeError));
    let fieldName = getOptionalObject(dto, "fieldName");
    if(fieldName !== undefined && fieldName !== null) {
      fieldName = SurveyLocalizedText.fromDTO(getObject(dto, "fieldName", InvalidOpenEndedFieldResultV1FieldNameError));
    }
    const openEndedResultsV1 = getList<OpenEndedResultV1DTO, OpenEndedResultV1>(
      dto,
      "openEndedResultsV1",
      OpenEndedResultV1.fromDTO,
      InvalidOpenEndedFieldResultV1OpenEndedResultsV1Error
    );
    return new OpenEndedFieldResultV1(
      fieldCode,
      fieldName,
      openEndedResultsV1
    );
  }

  toDTO(): OpenEndedFieldResultV1DTO {
    const dto: OpenEndedFieldResultV1DTO = {
        fieldCode: this.fieldCode.toDTO(),
        openEndedResultsV1: this.openEndedResultsV1.map((e: OpenEndedResultV1) => { return e.toDTO() })
    };
    if (this.fieldName !== undefined && this.fieldName !== null){
      dto.fieldName = this.fieldName.toDTO();
    }
    return dto;
  }
  private static validateOpenEndedResultsV1 = (openEndedResultsV1: OpenEndedResultV1[]): void => {
    if(openEndedResultsV1.length > 50) {
      throw new InvalidOpenEndedFieldResultV1OpenEndedResultsV1MaxSizeError(
        50,
        `Attribute openEndedResultsV1 is too long. Size is ${openEndedResultsV1.length}. Max size is 50.`
      );
    }
  }
  
}

OpenEndedFieldResultV1.prototype.toString = function toString(): string {
  return `OpenEndedFieldResultV1(fieldCode='${this.fieldCode}',fieldName='${this.fieldName}',openEndedResultsV1='${this.openEndedResultsV1}')`;
};

export class InvalidOpenEndedFieldResultV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResultV1Error";
  }
}
export class InvalidOpenEndedFieldResultV1FieldCodeError extends InvalidOpenEndedFieldResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResultV1FieldCodeError";
  }
}

export class InvalidOpenEndedFieldResultV1FieldNameError extends InvalidOpenEndedFieldResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResultV1FieldNameError";
  }
}

export class InvalidOpenEndedFieldResultV1OpenEndedResultsV1Error extends InvalidOpenEndedFieldResultV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResultV1OpenEndedResultsV1Error";
  }
}

export class InvalidOpenEndedFieldResultV1OpenEndedResultsV1MaxSizeError extends InvalidOpenEndedFieldResultV1OpenEndedResultsV1Error {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidOpenEndedFieldResultV1OpenEndedResultsV1MaxSizeError";
  }
}
